import React from 'react';
import { useParams } from 'react-router-dom';

import { ItemDetails } from './item-details';
import { useGetBank } from '../../../hooks/use-inventory-bank';
import { GameDocumentContext } from '../../../contexts/game-document';
import { GetItemTitle } from '../../../utils/game-document/assets';

export const InventoryBankPage = () => {
  const { gameCode } = useParams();
  const [gameDocument] = React.useContext(GameDocumentContext);

  const [selectedItemId, setSelectedItemId] = React.useState<string>();
  const [activeTab, setActiveTab] = React.useState<number>(0);

  const { data } = useGetBank(gameCode ?? '');

  const items = React.useMemo(() => {
    if (!gameDocument.gameDocument) return [];
    return gameDocument.gameDocument.assets.items ?? [];
  }, [gameDocument]);

  return (
    <div className={'row flex-grow-1 h-100 m-0 p-0 overflow-hidden'}>
      <div
        className={'col-2 d-flex flex-column h-100 overflow-auto p-0'}
        style={{
          border: '2px solid #efefef'
        }}>
        {data && data.items.length > 0 && (
          <ul className="list-group facilitator-border-none p-2">
            {data.items.map((item) => (
              <li
                className="list-group-item cursor-pointer"
                onClick={() => setSelectedItemId(item.itemId)}>
                <small
                  className={`${
                    selectedItemId === item.itemId
                      ? 'fw-bold text-dark'
                      : 'text-dark'
                  }`}>
                  {GetItemTitle(gameDocument.gameDocument, item.itemId)}
                </small>
              </li>
            ))}
          </ul>
        )}
      </div>

      {selectedItemId && (
        <ItemDetails
          key={selectedItemId}
          activeTab={activeTab}
          items={data?.items ?? []}
          selectedItemId={selectedItemId}
          setActiveTab={setActiveTab}
        />
      )}
    </div>
  );
};
